import React, { useEffect,useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import PageBanner from '../ui/PageBanner';
import ServicesList from '../components/services/ServicesList';

import servicesBannerImage from '../assets/Services/ServicesBanner.jpg';

import sdImage from '../assets/Services/services1.jpg';
import scImage from '../assets/Services/services2.jpg';
import aiImage from '../assets/Services/services3.jpg';
import iotImage from '../assets/Services/services4.jpg';

import hsdImage from '../assets/Home/services/sdImage.jpg'
import hscImage from '../assets/Home/services/scImage.jpg'
import hiotImage from '../assets/Home/services/iotImg.jpg'
import haiImage from '../assets/Home/services/aiImage.jpg'

import Preloader from '../ui/Preloader';

import { useNavigate } from 'react-router-dom';

const services = [
  {
    id: "software-development",
    title: 'Software Development',
    image: sdImage,
    icon:hsdImage,
    paragraphs: [
      `At ESMOB Technologies, we deliver end-to-end software development services across web, cloud, enterprise, and mobile platforms. Our experienced team of designers, developers, and QA specialists is equipped to handle projects of any scale, from startups to large enterprises.`,
      `We specialize in custom software solutions, including desktop applications, cloud computing, DevOps, quality assurance, and UI/UX design. Our agile development approach ensures flexibility, faster delivery, and continuous improvement throughout the project lifecycle.`,
      `With a strong track record across industries, we build scalable, secure, and performance-driven applications tailored to your unique business needs. Whether you're looking to develop a new product or enhance an existing system, ESMOB Technologies is your trusted partner in driving digital transformation.`,
    ],
  },
  {
    id: 'software-consulting',
    title: 'Software Consulting',
    image: scImage,
    icon:hscImage,
    paragraphs: [
      `At ESMOB Technologies, we offer software consulting services focused on optimizing IT systems to deliver real business value. Our goal is to improve performance, reduce costs, and ensure your technology supports long-term growth.`,
      `We don’t promote new technologies just to appear modern. Instead, we recommend solutions that align with your business goals and deliver tangible outcomes. Whether it's modernizing legacy systems, improving service reliability, or accelerating digital initiatives, we provide practical, cost-effective guidance.`,
      `Our consultants work closely with your team to assess your current IT landscape, identify opportunities for improvement, and design tailored solutions. We help streamline operations and enable faster, more efficient delivery of new IT services.`,
      `With a strong focus on results and reliability, ESMOB Technologies ensures that every IT investment supports your business strategy—empowering your organization to adapt, scale, and thrive in a competitive landscape.`
    ],
  },
  {
    id: 'artificial-intelligence',
    title: 'Artificial Intelligence',
    image: aiImage,
    icon:haiImage,
    paragraphs: [
      `At ESMOB Technologies, we help businesses harness the power of Artificial Intelligence to drive innovation, efficiency, and growth. Our AI consulting services are tailored to meet the unique needs of your industry—whether it's healthcare, advertising, finance, retail, or any specialized sector.`,
      `We implement AI models that enhance key business functions by automating repetitive tasks, streamlining operations, and enabling data-driven decision-making. From predictive analytics and natural language processing to intelligent automation and machine learning, we integrate cutting-edge AI technologies into your workflows to boost performance and reduce operational costs.`,
      `Our goal is to make AI practical and accessible, helping you transform complex challenges into strategic advantages. With a focus on measurable outcomes, we guide your organization through every stage of AI adoption—from initial planning and model development to deployment and continuous improvement.`,
      `Unlock new possibilities with ESMOB’s AI solutions and stay ahead in a rapidly evolving digital world.`
    ],
  },
  {
    id: 'iot',
    title: 'Internet of Things',
    image: iotImage,
    icon:hiotImage,
    paragraphs: [
      `At ESMOB Technologies, we empower businesses of all sizes to unlock innovation and growth through smart IoT solutions. While large enterprises have long benefited from IoT, small and medium businesses now have the opportunity to gain a competitive edge by embracing this transformative technology.`,
      `We specialize in full-stack IoT development and embedded systems for industries and connected vehicles. Our expertise extends to AI and machine learning integration, enabling advanced capabilities like predictive maintenance and intelligent driver monitoring applications.`,
      `From sensor integration and real-time data processing to selecting the right platforms, we provide end-to-end IoT services tailored to your unique needs. Our goal is to help organizations turn business challenges into opportunities by leveraging connected technology that delivers actionable insights and operational efficiency.`,
      `Partner with ESMOB to develop IoT-powered solutions that drive productivity, improve safety, and fuel data-driven decision-making in a connected world.`
    ],
  },
];

const Services = () => {
  const navigate=useNavigate();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(delay);
  }, []);

  return (
    <>
    {loading ? (
      <Preloader />
    ) : (
      <div className="font-roboto">
      <PageBanner title="Services" breadcrumb="Services" backgroundImage={servicesBannerImage} />

      <div className="bg-white py-12 px-4 text-center" data-aos="fade-up">
        <h2
          className="text-xl md:text-2xl 2xl:text-3xl font-semibold text-gray-900 max-w-5xl mx-auto leading-relaxed"
          
        >
          From custom software and strategic consulting to AI and IoT development, we deliver smart, scalable, and reliable solutions tailored to your industry needs.
        </h2>
        <div className="w-12 h-0.5 bg-[#2584C6] mx-auto mt-2 rounded"></div>
      </div>

      <ServicesList services={services} />
      <div className="bg-gray-200 py-10 mt-1 mb-1 rounded-lg  mx-auto w-[92vw]">
      <div className='flex justify-center w-full'  data-aos="zoom-in">
  <button
    onClick={() => navigate('/contact')}
    className="w-[50vw] bg-[#F7941D] text-white px-10 py-6 font-semibold hover:bg-orange-500 transition duration-300 rounded-lg shadow-lg"
  >
    Contact Us
  </button>
</div>
      </div>

    </div>
    )}
    </>
  );
};

export default Services;
